import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetTotalCreditRepaidQuery = ({
  timePeriod,
  customStartDate,
  customEndDate,
}: {
  timePeriod?: string;
  customStartDate?: string;
  customEndDate?: string;
}) => {
  const token = getToken();

  const params: Record<string, string> = {};
  if (timePeriod) params.timePeriod = timePeriod;
  if (customStartDate) params.customStartDate = customStartDate;
  if (customEndDate) params.customEndDate = customEndDate;

  return useQuery({
    queryKey: [
      "useGetTotalCreditRepaidQuery",
      timePeriod,
      customStartDate,
      customEndDate,
    ],
    queryFn: () =>
      axiosInstance
        .get("dashboard/total-credits-repaid", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        })
        .then((res) => res.data),

    enabled: !!token,
  });
};
